export enum DashboardTableContentType {
  Unassigned,
  Returned,
}
